import type { Router } from 'vue-router';

const key = 'zhiwei.library.entry.v1';
let memoryEntry = '';
export function safeLibraryReturn(value: unknown): string {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\r\n]/.test(value))
    return '';
  const url = new URL(value, 'https://local.invalid');
  if (url.origin !== 'https://local.invalid' || /^\/(?:zhiwei|ai-visualization|login|signup|callback)(?:\/|$)/.test(url.pathname))
    return '';
  return `${url.pathname}${url.search}${url.hash}`;
}
export function libraryReturnTarget(explicit?: unknown): string {
  let stored = memoryEntry;
  try {
    stored = sessionStorage.getItem(key) || stored;
  }
  catch { /* Same-tab memory still works when storage is blocked. */ }
  return safeLibraryReturn(explicit) || safeLibraryReturn(stored) || '/my-courses';
}
export function installLibraryEntryTracking(router: Router): void {
  router.afterEach((to, from, failure) => {
    if (failure || !/^\/(?:zhiwei|ai-visualization)(?:\/|$)/.test(to.path))
      return;
    const entry = safeLibraryReturn(to.query.returnTo) || (from.matched.length ? safeLibraryReturn(from.fullPath) : '');
    if (!entry)
      return;
    memoryEntry = entry;
    try {
      sessionStorage.setItem(key, entry);
    }
    catch { /* Navigation never depends on persistent storage. */ }
  });
}
